var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMaximize = function SvgMaximize(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.36 7.23-3.64 3.71c-.49.17-.75-.43-.47-.92l3.48-3.45h-1.58c-.29 0-.48-.92.03-1.03.85.05 1.91-.11 2.79.01.24.03.37.16.4.43.1.89-.06 1.96-.01 2.89-.11.49-1 .28-1-.01zM7.75 6.57l3.54 3.45c.37.49-.15 1.07-.65.65L7.36 7.23v1.62c0 .3-.9.5-1.01.02.05-.93-.11-2-.01-2.89.03-.27.15-.4.39-.43.88-.12 1.94.04 2.79-.01.51.11.31 1.03.02 1.03zM7.75 17.43h1.79c.29 0 .49.92-.02 1.03-.85-.05-1.91.11-2.79-.01-.24-.03-.36-.16-.39-.43-.1-.89.06-1.96.01-2.89.11-.49 1.01-.28 1.01.01v1.63l3.28-3.44c.5-.42 1.02.16.65.65zM17.36 16.77v-1.63c0-.29.9-.5 1-.01-.05.93.11 2 .01 2.89-.03.27-.15.4-.4.43-.88.12-1.94-.04-2.79.01-.51-.11-.32-1.03-.03-1.03h1.58l-3.53-3.45c-.36-.49.15-1.07.65-.65z"
  })));
};
export { SvgMaximize as ReactComponent };
export default __webpack_public_path__ + "static/media/maximize.ad37cf852267203cfa21b1b31bddb63b.svg";